import { toast } from "react-toastify";
import { getDomain, getUserData, getUserId } from "../../../Base/helper/baseFunctions";
import axiosInstance from "../../../../../axiosInstance";
import { HRMS_FINANCE_API_URL } from "../../../../Constants/baseConstant";

export const AddEmployeeTemplateHelper = async (params) => {
    const data = getUserData();
    toast.dismiss()
    toast.info("Saving...")
    return await axiosInstance(`/finance/addEmployeeTemplate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
            earnings: params?.earnings,
            deductions: params?.deductions,
            employee_id: params?.employee_id,
            overtime_applicable_flag: params?.overtime_applicable_flag ? params?.overtime_applicable_flag : false,
            payroll_onhold: params?.payroll_onhold ? params?.payroll_onhold : false,
            overtime_configuration_pk: params?.overtime_configuration_pk ? params?.overtime_configuration_pk : null,
        }
    })
        .then((res) => {
            toast.dismiss()
            toast.success("Template Added Successfully")
            return { message: "Template Added Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss()
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Unable to add Template", hasError: false, data: err?.response?.data }
        })
}
export const UpdateEmployeeTemplateHelper = async (params) => {
    const data = getUserData();
    toast.dismiss()
    toast.info("Saving...")
    return await axiosInstance(`/finance/updateEmployeeTemplate`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: getUserId(),
            employee_id: params?.employee_id,
            earnings: params?.earnings,
            deductions: params?.deductions,
            overtime_applicable_flag: params?.overtime_applicable_flag ? params?.overtime_applicable_flag : false,
            payroll_onhold: params?.payroll_onhold ? params?.payroll_onhold : false,
            overtime_configuration_pk: params?.overtime_configuration_pk ? params?.overtime_configuration_pk : null,

        }
    })
        .then((res) => {
            toast.dismiss()
            toast.success("Template Updated Successfully")
            return { message: "Template Updated Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss()
            toast.error(err?.response?.data?.error?.[0]?.message)
            return { message: "Unable to update Template", hasError: false, data: err?.response?.data }
        })
}
export const GetEmployeeTemplateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/getEmployeeTemplate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            employee_id: params?.employee_id
        }
    })
        .then((res) => {
            return { message: "Template retrived successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived Template", hasError: false, data: err?.response?.data }
        })
}
export const CalculateEmployeeSalaryTemplateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/CalculateEmployeeSalaryTemplate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            ctc: +params?.ctc,
            payroll_worklocation_id: null,
            basic: +params?.basic,
            hra: +params?.hra,
            conveyance_allowance: params?.conveyance_allowance_flag ? +params?.conveyance_allowance : 0,
            medical_allowance: params?.medical_allowance_flag ? +params?.medical_allowance : 0,
            educational_allowance: params?.educational_allowance_flag ? +params?.educational_allowance : 0,
            lta: params?.lta_flag ? +params?.lta : 0,
            esic: params?.esic ? params?.esic : false,
            pt: params?.pt ? params?.pt : false,
            country: "india",
            pf: params?.pf ? params?.pf : false,
            eps_applicable_flag: params?.pf ? (params?.eps_applicable_flag ?? false) : false,
            pf_limit_applicable: params?.pf ? params?.pf_limit_applicable : false,
            pf_limit_amount: (params?.pf && params?.pf_limit_applicable) ? params?.pf_limit_amount : null,
            pf_variable_components: params?.pf ? params?.pf_variable_components : null,
            pf_earnings_applicable: params?.pf_earnings_applicable ? params?.pf_earnings_applicable : false,
            statutory_bonus_flag: params?.statutory_bonus_flag ? params?.statutory_bonus_flag : false,
            employee_id: params?.employee_id,
            gratuity_flag: params?.gratuity_flag ? params?.gratuity_flag : false,
        }
    })
        .then((res) => {
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}
export const AddCalculateEmployeeSalaryTemplateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/AddCalculateEmployeeSalaryTemplate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            payroll_worklocation_id: null,
            ctc: params?.ctc,
            basic_percentage: params?.basic_percentage,
            hra_percentage: params?.hra_percentage,
            conveyance_allowance: params?.conveyance_allowance,
            medical_allowance: params?.medical_allowance,
            lta_percentage: params?.lta,
            basic: params?.basic,
            epf_earning: params?.epf_earning,
            esi_earning: params?.esi_earning,
            hra: params?.hra,
            lta: params?.lta,
            educational_allowance: params?.educational_allowance,
            special_allowance: params?.special_allowance,
            epf_deduction: params?.epf_deduction,
            pt_deduction: params?.pt_deduction,
            esi_deduction: params?.esi_deduction,
            user_id: getUserId(),
            employee_id: params?.employee_id,
            conveyance_allowance_flag: params?.conveyance_allowance_flag ? params?.conveyance_allowance_flag : false,
            medical_allowance_flag: params?.medical_allowance_flag ? params?.medical_allowance_flag : false,
            educational_allowance_flag: params?.educational_allowance_flag ? params?.educational_allowance_flag : false,
            lta_flag: params?.lta_flag ? params?.lta_flag : false,
            esic_flag: params?.esic_flag ? params?.esic_flag : false,
            pt_flag: params?.pt_flag ? params?.pt_flag : false,
            overtime_applicable_flag: params?.overtime_applicable_flag ? params?.overtime_applicable_flag : false,
            payroll_onhold: params?.payroll_onhold ? params?.payroll_onhold : false,
            pf_flag: params?.pf_flag ? params?.pf_flag : false,
            eps_applicable_flag: params?.eps_applicable_flag ? params?.eps_applicable_flag : false,
            pf_limit_applicable_flag: params?.pf_limit_applicable_flag ? params?.pf_limit_applicable_flag : false,
            pf_limit_amount: (params?.pf_flag && params?.pf_limit_applicable_flag) ? params?.pf_limit_amount : null,
            pf_variable_components: params?.pf_flag ? params?.pf_variable_components : null,
            pf_earnings_applicable: params?.pf_earnings_applicable ? params?.pf_earnings_applicable : false,
            overtime_configuration_pk: params?.overtime_configuration_pk ? params?.overtime_configuration_pk : null,
            transport_applicable: params?.transport_applicable,
            transport_earnings: params?.transport_earnings,
            transport_deductions: params?.transport_deductions,
            food_applicable: params?.food_applicable,
            food_earnings: params?.food_earnings,
            food_deductions: params?.food_deductions,
            statutory_bonus_flag: params?.statutory_bonus_flag ? params?.statutory_bonus_flag : false,
            statutory_bonus: params?.statutory_bonus ? params?.statutory_bonus : null,
            gratuity_flag: params?.gratuity_flag ? params?.gratuity_flag : false,
            fixed_wages: params?.fixed_wages ? params?.fixed_wages : null,
            adjusted_wages: params?.adjusted_wages ? params?.adjusted_wages : null,
            pf_compliant_flag: params?.pf_compliant_flag ? params?.pf_compliant_flag : false,
            ex_gratia: params?.ex_gratia ? params?.ex_gratia : null,
            weekoff_caln_applicable: params?.weekoff_caln_applicable ?? true,
            monthly_working_hrs_calc: params?.monthly_working_hrs_calc ? params?.monthly_working_hrs_calc : false,
        }
    })
        .then((res) => {
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}
export const CalculateEmployeeAdvanceSalaryTemplateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/CalculateEmployeeAdvanceSalaryTemplate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            ctc: +params?.ctc,
            payroll_worklocation_id: null,
            basic: +params?.basic,
            hra: +params?.hra,
            conveyance_allowance: params?.conveyance_allowance_flag ? +params?.conveyance_allowance : 0,
            medical_allowance: params?.medical_allowance_flag ? +params?.medical_allowance : 0,
            educational_allowance: params?.educational_allowance_flag ? +params?.educational_allowance : 0,
            lta: params?.lta_flag ? +params?.lta : 0,
            esic: params?.esic ? params?.esic : false,
            pt: params?.pt ? params?.pt : false,
            country: "india",
            variable_percentage: +params?.variable_percentage,
            pf: params?.pf ? params?.pf : false,
            eps_applicable_flag: params?.pf ? (params?.eps_applicable_flag ?? false) : false,
            pf_limit_applicable: params?.pf ? params?.pf_limit_applicable : false,
            pf_limit_amount: (params?.pf && params?.pf_limit_applicable) ? params?.pf_limit_amount : null,
            earning_component_json: params?.earning_component_json,
            deduction_component_json: params?.deduction_component_json,
            pf_variable_components: params?.pf ? params?.pf_variable_components : null,
            pf_earnings_applicable: params?.pf_earnings_applicable ? params?.pf_earnings_applicable : false,
            statutory_bonus_flag: params?.statutory_bonus_flag ? params?.statutory_bonus_flag : false,
            employee_id: params?.employee_id,
            gratuity_flag: params?.gratuity_flag ? params?.gratuity_flag : false,
        }
    })
        .then((res) => {
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}
export const AddCalculateEmployeeAdvanceSalaryTemplateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/AddCalculateEmployeeAdvanceSalaryTemplate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            payroll_worklocation_id: null,
            ctc: params?.ctc,
            basic_percentage: params?.basic_percentage,
            hra_percentage: params?.hra_percentage,
            conveyance_allowance: params?.conveyance_allowance,
            medical_allowance: params?.medical_allowance,
            lta_percentage: params?.lta,
            basic: params?.basic,
            epf_earning: params?.epf_earning,
            esi_earning: params?.esi_earning,
            hra: params?.hra,
            lta: params?.lta,
            educational_allowance: params?.educational_allowance,
            special_allowance: params?.special_allowance,
            epf_deduction: params?.epf_deduction,
            pt_deduction: params?.pt_deduction,
            esi_deduction: params?.esi_deduction,
            user_id: getUserId(),
            employee_id: params?.employee_id,
            conveyance_allowance_flag: params?.conveyance_allowance_flag ? params?.conveyance_allowance_flag : false,
            medical_allowance_flag: params?.medical_allowance_flag ? params?.medical_allowance_flag : false,
            educational_allowance_flag: params?.educational_allowance_flag ? params?.educational_allowance_flag : false,
            lta_flag: params?.lta_flag ? params?.lta_flag : false,
            esic_flag: params?.esic_flag ? params?.esic_flag : false,
            pt_flag: params?.pt_flag ? params?.pt_flag : false,
            overtime_applicable_flag: params?.overtime_applicable_flag ? params?.overtime_applicable_flag : false,
            pf_flag: params?.pf_flag ? params?.pf_flag : false,
            eps_applicable_flag: params?.eps_applicable_flag ? params?.eps_applicable_flag : false,
            pf_limit_applicable_flag: params?.pf_limit_applicable_flag ? params?.pf_limit_applicable_flag : false,
            pf_limit_amount: (params?.pf_flag && params?.pf_limit_applicable_flag) ? params?.pf_limit_amount : null,
            variable_percentage: params?.variable_percentage,
            variable_pay: params?.variable_pay,
            earning_component_json: params?.earning_component_json,
            payroll_onhold: params?.payroll_onhold ? params?.payroll_onhold : false,
            deduction_component_json: params?.deduction_component_json,
            pf_variable_components: params?.pf_flag ? params?.pf_variable_components : null,
            pf_earnings_applicable: params?.pf_earnings_applicable ? params?.pf_earnings_applicable : false,
            overtime_configuration_pk: params?.overtime_configuration_pk ? params?.overtime_configuration_pk : null,
            transport_applicable: params?.transport_applicable,
            transport_earnings: params?.transport_earnings,
            transport_deductions: params?.transport_deductions,
            food_applicable: params?.food_applicable,
            food_earnings: params?.food_earnings,
            food_deductions: params?.food_deductions,
            statutory_bonus_flag: params?.statutory_bonus_flag ? params?.statutory_bonus_flag : false,
            statutory_bonus: params?.statutory_bonus ? params?.statutory_bonus : null,
            gratuity_flag: params?.gratuity_flag ? params?.gratuity_flag : false,
            fixed_wages: params?.fixed_wages ? params?.fixed_wages : null,
            adjusted_wages: params?.adjusted_wages ? params?.adjusted_wages : null,
            pf_compliant_flag: params?.pf_compliant_flag ? params?.pf_compliant_flag : false,
            ex_gratia: params?.ex_gratia ? params?.ex_gratia : null,
            weekoff_caln_applicable: params?.weekoff_caln_applicable ?? true,
            monthly_working_hrs_calc: params?.monthly_working_hrs_calc ? params?.monthly_working_hrs_calc : false,
        }
    })
        .then((res) => {
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}
// contractual
export const CalculateEmployeeContractualSalaryTemplateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/CalculateEmployeeContractualSalaryTemplate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            ctc: null, // not required
            payroll_worklocation_id: null,
            basic: null, //
            hra: null, //
            conveyance_allowance: params?.conveyance_allowance_flag ? +params?.conveyance_allowance : 0,
            medical_allowance: params?.medical_allowance_flag ? +params?.medical_allowance : 0,
            educational_allowance: params?.educational_allowance_flag ? +params?.educational_allowance : 0,
            lta: params?.lta_flag ? +params?.lta : 0,
            esic: params?.esic ? params?.esic : false,
            pt: params?.pt ? params?.pt : false,
            country: "india",
            variable_percentage: null, //
            pf: params?.pf ? params?.pf : false,
            eps_applicable_flag: params?.pf ? (params?.eps_applicable_flag ?? false) : false,
            pf_limit_applicable: params?.pf ? params?.pf_limit_applicable : false,
            pf_limit_amount: (params?.pf && params?.pf_limit_applicable) ? params?.pf_limit_amount : null,
            earning_component_json: params?.earning_component_json,
            deduction_component_json: params?.deduction_component_json,
            pf_variable_components: params?.pf ? params?.pf_variable_components : null,
            pf_earnings_applicable: params?.pf_earnings_applicable ? params?.pf_earnings_applicable : false,
            statutory_bonus_flag: params?.statutory_bonus_flag ? params?.statutory_bonus_flag : false,
            employee_id: params?.employee_id,
        }
    })
        .then((res) => {
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}

export const AddCalculateEmployeeContractualSalaryTemplateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/AddCalculateEmployeeContractualSalaryTemplate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            payroll_worklocation_id: null, // not required
            conveyance_allowance: params?.conveyance_allowance,
            medical_allowance: params?.medical_allowance,
            lta_percentage: params?.lta,
            epf_earning: params?.epf_earning,
            esi_earning: params?.esi_earning,
            lta: params?.lta,
            educational_allowance: params?.educational_allowance,
            special_allowance: params?.special_allowance,
            epf_deduction: params?.epf_deduction,
            pt_deduction: params?.pt_deduction,
            esi_deduction: params?.esi_deduction,
            user_id: getUserId(),
            employee_id: params?.employee_id,
            conveyance_allowance_flag: params?.conveyance_allowance_flag ? params?.conveyance_allowance_flag : false,
            medical_allowance_flag: params?.medical_allowance_flag ? params?.medical_allowance_flag : false,
            educational_allowance_flag: params?.educational_allowance_flag ? params?.educational_allowance_flag : false,
            lta_flag: params?.lta_flag ? params?.lta_flag : false,
            esic_flag: params?.esic_flag ? params?.esic_flag : false,
            pt_flag: params?.pt_flag ? params?.pt_flag : false,
            overtime_applicable_flag: params?.overtime_applicable_flag ? params?.overtime_applicable_flag : false,
            pf_flag: params?.pf_flag ? params?.pf_flag : false,
            eps_applicable_flag: params?.eps_applicable_flag ? params?.eps_applicable_flag : false,
            pf_limit_applicable_flag: params?.pf_limit_applicable_flag ? params?.pf_limit_applicable_flag : false,
            pf_limit_amount: (params?.pf_flag && params?.pf_limit_applicable_flag) ? params?.pf_limit_amount : null,
            earning_component_json: params?.earning_component_json,
            payroll_onhold: params?.payroll_onhold ? params?.payroll_onhold : false,
            deduction_component_json: params?.deduction_component_json,
            pf_variable_components: params?.pf_flag ? params?.pf_variable_components : null,
            pf_earnings_applicable: params?.pf_earnings_applicable ? params?.pf_earnings_applicable : false,
            overtime_configuration_pk: params?.overtime_configuration_pk ? params?.overtime_configuration_pk : null,
            leave_wages_applicable: params?.leave_wages_applicable,
            transport_applicable: params?.transport_applicable,
            transport_earnings: params?.transport_earnings,
            transport_deductions: params?.transport_deductions,
            ph_wages_applicable: params?.ph_wages_applicable,
            food_applicable: params?.food_applicable,
            food_earnings: params?.food_earnings,
            food_deductions: params?.food_deductions,
            weekoff_caln_applicable: params?.weekoff_caln_applicable ?? true,
            statutory_bonus_flag: params?.statutory_bonus_flag ? params?.statutory_bonus_flag : false,
            statutory_bonus: params?.statutory_bonus ? params?.statutory_bonus : null,
            fixed_wages: params?.fixed_wages ? params?.fixed_wages : null,
            adjusted_wages: params?.adjusted_wages ? params?.adjusted_wages : null,
            pf_compliant_flag: params?.pf_compliant_flag ? params?.pf_compliant_flag : false,
            ex_gratia: params?.ex_gratia ? params?.ex_gratia : null,
            monthly_working_hrs_calc: params?.monthly_working_hrs_calc ? params?.monthly_working_hrs_calc : false,
        }
    })
        .then((res) => {
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}
//contractualDaily
export const CalculateEmployeeContractualDailySalaryTemplateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/CalculateEmployeeContractualDailySalaryTemplate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            ctc: null, // not required
            payroll_worklocation_id: null,
            basic: null, //
            hra: null, //
            conveyance_allowance: params?.conveyance_allowance_flag ? +params?.conveyance_allowance : 0,
            medical_allowance: params?.medical_allowance_flag ? +params?.medical_allowance : 0,
            educational_allowance: params?.educational_allowance_flag ? +params?.educational_allowance : 0,
            lta: params?.lta_flag ? +params?.lta : 0,
            esic: params?.esic ? params?.esic : false,
            pt: params?.pt ? params?.pt : false,
            country: "india",
            variable_percentage: null, //
            pf: params?.pf ? params?.pf : false,
            eps_applicable_flag: params?.pf ? (params?.eps_applicable_flag ?? false) : false,
            pf_limit_applicable: params?.pf ? params?.pf_limit_applicable : false,
            pf_limit_amount: (params?.pf && params?.pf_limit_applicable) ? params?.pf_limit_amount : null,
            earning_component_json: params?.earning_component_json,
            deduction_component_json: params?.deduction_component_json,
            pf_variable_components: params?.pf ? params?.pf_variable_components : null,
            pf_earnings_applicable: params?.pf_earnings_applicable ? params?.pf_earnings_applicable : false,
            statutory_bonus_flag: params?.statutory_bonus_flag ? params?.statutory_bonus_flag : false,
            employee_id: params?.employee_id,
        }
    })
        .then((res) => {
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}

export const AddCalculateEmployeeContractualDailySalaryTemplateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/AddCalculateEmployeeContractualDailySalaryTemplate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            payroll_worklocation_id: null, // not required
            conveyance_allowance: params?.conveyance_allowance,
            medical_allowance: params?.medical_allowance,
            lta_percentage: params?.lta,
            epf_earning: params?.epf_earning,
            esi_earning: params?.esi_earning,
            lta: params?.lta,
            educational_allowance: params?.educational_allowance,
            special_allowance: params?.special_allowance,
            epf_deduction: params?.epf_deduction,
            pt_deduction: params?.pt_deduction,
            esi_deduction: params?.esi_deduction,
            user_id: getUserId(),
            employee_id: params?.employee_id,
            conveyance_allowance_flag: params?.conveyance_allowance_flag ? params?.conveyance_allowance_flag : false,
            medical_allowance_flag: params?.medical_allowance_flag ? params?.medical_allowance_flag : false,
            educational_allowance_flag: params?.educational_allowance_flag ? params?.educational_allowance_flag : false,
            lta_flag: params?.lta_flag ? params?.lta_flag : false,
            esic_flag: params?.esic_flag ? params?.esic_flag : false,
            pt_flag: params?.pt_flag ? params?.pt_flag : false,
            overtime_applicable_flag: params?.overtime_applicable_flag ? params?.overtime_applicable_flag : false,
            pf_flag: params?.pf_flag ? params?.pf_flag : false,
            eps_applicable_flag: params?.eps_applicable_flag ? params?.eps_applicable_flag : false,
            pf_limit_applicable_flag: params?.pf_limit_applicable_flag ? params?.pf_limit_applicable_flag : false,
            pf_limit_amount: (params?.pf_flag && params?.pf_limit_applicable_flag) ? params?.pf_limit_amount : null,
            earning_component_json: params?.earning_component_json,
            payroll_onhold: params?.payroll_onhold ? params?.payroll_onhold : false,
            deduction_component_json: params?.deduction_component_json,
            pf_variable_components: params?.pf_flag ? params?.pf_variable_components : null,
            pf_earnings_applicable: params?.pf_earnings_applicable ? params?.pf_earnings_applicable : false,
            overtime_configuration_pk: params?.overtime_configuration_pk ? params?.overtime_configuration_pk : null,
            leave_wages_applicable: params?.leave_wages_applicable,
            transport_applicable: params?.transport_applicable,
            transport_earnings: params?.transport_earnings,
            transport_deductions: params?.transport_deductions,
            ph_wages_applicable: params?.ph_wages_applicable,
            food_applicable: params?.food_applicable,
            food_earnings: params?.food_earnings,
            food_deductions: params?.food_deductions,
            weekoff_caln_applicable: params?.weekoff_caln_applicable ?? true,
            statutory_bonus_flag: params?.statutory_bonus_flag ? params?.statutory_bonus_flag : false,
            statutory_bonus: params?.statutory_bonus ? params?.statutory_bonus : null,
            fixed_wages: params?.fixed_wages ? params?.fixed_wages : null,
            adjusted_wages: params?.adjusted_wages ? params?.adjusted_wages : null,
            pf_compliant_flag: params?.pf_compliant_flag ? params?.pf_compliant_flag : false,
            ex_gratia: params?.ex_gratia ? params?.ex_gratia : null,
            monthly_working_hrs_calc: params?.monthly_working_hrs_calc ? params?.monthly_working_hrs_calc : false,
        }
    })
        .then((res) => {
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}

// contractual PayableDays
export const CalculateContractualPayableDaysSalaryTemplateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/CalculateContractualPayableDaysSalaryTemplate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            ctc: null, // not required
            payroll_worklocation_id: null,
            basic: null, //
            hra: null, //
            conveyance_allowance: params?.conveyance_allowance_flag ? +params?.conveyance_allowance : 0,
            medical_allowance: params?.medical_allowance_flag ? +params?.medical_allowance : 0,
            educational_allowance: params?.educational_allowance_flag ? +params?.educational_allowance : 0,
            lta: params?.lta_flag ? +params?.lta : 0,
            esic: params?.esic ? params?.esic : false,
            pt: params?.pt ? params?.pt : false,
            country: "india",
            variable_percentage: null, //
            pf: params?.pf ? params?.pf : false,
            eps_applicable_flag: params?.pf ? (params?.eps_applicable_flag ?? false) : false,
            pf_limit_applicable: params?.pf ? params?.pf_limit_applicable : false,
            pf_limit_amount: (params?.pf && params?.pf_limit_applicable) ? params?.pf_limit_amount : null,
            earning_component_json: params?.earning_component_json,
            deduction_component_json: params?.deduction_component_json,
            pf_variable_components: params?.pf ? params?.pf_variable_components : null,
            pf_earnings_applicable: params?.pf_earnings_applicable ? params?.pf_earnings_applicable : false,
            statutory_bonus_flag: params?.statutory_bonus_flag ? params?.statutory_bonus_flag : false,
            employee_id: params?.employee_id,
        }
    })
        .then((res) => {
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}

export const AddCalculateContractualPayableDaysSalaryTemplateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/AddCalculateContractualPayableDaysSalaryTemplate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            payroll_worklocation_id: null, // not required
            conveyance_allowance: params?.conveyance_allowance,
            medical_allowance: params?.medical_allowance,
            lta_percentage: params?.lta,
            epf_earning: params?.epf_earning,
            esi_earning: params?.esi_earning,
            lta: params?.lta,
            educational_allowance: params?.educational_allowance,
            special_allowance: params?.special_allowance,
            epf_deduction: params?.epf_deduction,
            pt_deduction: params?.pt_deduction,
            esi_deduction: params?.esi_deduction,
            user_id: getUserId(),
            employee_id: params?.employee_id,
            conveyance_allowance_flag: params?.conveyance_allowance_flag ? params?.conveyance_allowance_flag : false,
            medical_allowance_flag: params?.medical_allowance_flag ? params?.medical_allowance_flag : false,
            educational_allowance_flag: params?.educational_allowance_flag ? params?.educational_allowance_flag : false,
            lta_flag: params?.lta_flag ? params?.lta_flag : false,
            esic_flag: params?.esic_flag ? params?.esic_flag : false,
            pt_flag: params?.pt_flag ? params?.pt_flag : false,
            overtime_applicable_flag: params?.overtime_applicable_flag ? params?.overtime_applicable_flag : false,
            pf_flag: params?.pf_flag ? params?.pf_flag : false,
            eps_applicable_flag: params?.eps_applicable_flag ? params?.eps_applicable_flag : false,
            pf_limit_applicable_flag: params?.pf_limit_applicable_flag ? params?.pf_limit_applicable_flag : false,
            pf_limit_amount: (params?.pf_flag && params?.pf_limit_applicable_flag) ? params?.pf_limit_amount : null,
            earning_component_json: params?.earning_component_json,
            payroll_onhold: params?.payroll_onhold ? params?.payroll_onhold : false,
            deduction_component_json: params?.deduction_component_json,
            pf_variable_components: params?.pf_flag ? params?.pf_variable_components : null,
            pf_earnings_applicable: params?.pf_earnings_applicable ? params?.pf_earnings_applicable : false,
            overtime_configuration_pk: params?.overtime_configuration_pk ? params?.overtime_configuration_pk : null,
            leave_wages_applicable: params?.leave_wages_applicable,
            transport_applicable: params?.transport_applicable,
            transport_earnings: params?.transport_earnings,
            transport_deductions: params?.transport_deductions,
            ph_wages_applicable: params?.ph_wages_applicable,
            food_applicable: params?.food_applicable,
            food_earnings: params?.food_earnings,
            food_deductions: params?.food_deductions,
            weekoff_caln_applicable: params?.weekoff_caln_applicable ?? true,
            statutory_bonus_flag: params?.statutory_bonus_flag ? params?.statutory_bonus_flag : false,
            statutory_bonus: params?.statutory_bonus ? params?.statutory_bonus : null,
            fixed_wages: params?.fixed_wages ? params?.fixed_wages : null,
            adjusted_wages: params?.adjusted_wages ? params?.adjusted_wages : null,
            pf_compliant_flag: params?.pf_compliant_flag ? params?.pf_compliant_flag : false,
            ex_gratia: params?.ex_gratia ? params?.ex_gratia : null,
            monthly_working_hrs_calc: params?.monthly_working_hrs_calc ? params?.monthly_working_hrs_calc : false,
        }
    })
        .then((res) => {
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}

//  monthlyCtcTemplate
export const CalculateMonthlyCtcTemplateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/CalculateMonthlyCtcTemplate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            ctc: +params?.ctc,
            esic: params?.esic ? params?.esic : false,
            pt: params?.pt ? params?.pt : false,
            country: "india",
            pf: params?.pf ? params?.pf : false,
            eps_applicable_flag: params?.pf ? (params?.eps_applicable_flag ?? false) : false,
            pf_limit_applicable: params?.pf ? params?.pf_limit_applicable : false,
            pf_limit_amount: (params?.pf && params?.pf_limit_applicable) ? params?.pf_limit_amount : null,
            earning_component_json: params?.earning_component_json,
            deduction_component_json: params?.deduction_component_json,
            pf_variable_components: params?.pf ? params?.pf_variable_components : null,
            pf_earnings_applicable: params?.pf_earnings_applicable ? params?.pf_earnings_applicable : false,
            statutory_bonus_flag: params?.statutory_bonus_flag ? params?.statutory_bonus_flag : false,
            employee_id: params?.employee_id,
            gratuity_flag: params?.gratuity_flag ? params?.gratuity_flag : false,
        }
    })
        .then((res) => {
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}

export const AddCalculatemonthlyCtcTemplateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/AddCalculateMonthlyCtcTemplate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            ctc: params?.ctc,
            epf_earning: params?.epf_earning,
            esi_earning: params?.esi_earning,
            epf_deduction: params?.epf_deduction,
            pt_deduction: params?.pt_deduction,
            esi_deduction: params?.esi_deduction,
            user_id: getUserId(),
            employee_id: params?.employee_id,
            esic_flag: params?.esic_flag ? params?.esic_flag : false,
            pt_flag: params?.pt_flag ? params?.pt_flag : false,
            overtime_applicable_flag: params?.overtime_applicable_flag ? params?.overtime_applicable_flag : false,
            pf_flag: params?.pf_flag ? params?.pf_flag : false,
            eps_applicable_flag: params?.eps_applicable_flag ? params?.eps_applicable_flag : false,
            pf_limit_applicable_flag: params?.pf_limit_applicable_flag ? params?.pf_limit_applicable_flag : false,
            pf_limit_amount: (params?.pf_flag && params?.pf_limit_applicable_flag) ? params?.pf_limit_amount : null,
            earning_component_json: params?.earning_component_json,
            payroll_onhold: params?.payroll_onhold ? params?.payroll_onhold : false,
            deduction_component_json: params?.deduction_component_json,
            pf_variable_components: params?.pf_flag ? params?.pf_variable_components : null,
            pf_earnings_applicable: params?.pf_earnings_applicable ? params?.pf_earnings_applicable : false,
            overtime_configuration_pk: params?.overtime_configuration_pk ? params?.overtime_configuration_pk : null,
            transport_applicable: params?.transport_applicable,
            transport_earnings: params?.transport_earnings,
            transport_deductions: params?.transport_deductions,
            food_applicable: params?.food_applicable,
            food_earnings: params?.food_earnings,
            food_deductions: params?.food_deductions,
            statutory_bonus_flag: params?.statutory_bonus_flag ? params?.statutory_bonus_flag : false,
            statutory_bonus: params?.statutory_bonus ? params?.statutory_bonus : null,
            gratuity_flag: params?.gratuity_flag ? params?.gratuity_flag : false,
            fixed_wages: params?.fixed_wages ? params?.fixed_wages : null,
            adjusted_wages: params?.adjusted_wages ? params?.adjusted_wages : null,
            pf_compliant_flag: params?.pf_compliant_flag ? params?.pf_compliant_flag : false,
            ex_gratia: params?.ex_gratia ? params?.ex_gratia : null,
            weekoff_caln_applicable: params?.weekoff_caln_applicable ?? true,
            monthly_working_hrs_calc: params?.monthly_working_hrs_calc ? params?.monthly_working_hrs_calc : false,
        }
    })
        .then((res) => {
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}

export const UpdateDailyWageTemplateHelper = async (params) => {
    return await axiosInstance(`/finance/updateDailyWageTemplate`, {
        method: "PUT",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            employee_fk: params?.employee_fk,
            payroll_onhold: false,
            daily_wage_per_hr_amount: params?.daily_wage_per_hr_amount
        }
    })
        .then((res) => {
            return { message: "Template Updated Successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to update Template", hasError: false, data: err?.response?.data }
        })
}
export const GetCalculateEmployeeSalaryTemplateHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/GetCalculateEmployeeSalaryTemplate`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            employee_id: params?.employee_id
        }
    })
        .then((res) => {
            return { message: "Template retrived successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived Template", hasError: false, data: err?.response?.data }
        })
}

export const onholdEmployeeHelper = async (params) => {
    const data = getUserData();
    return await axiosInstance(`/finance/onholdEmployee`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: data?.domain,
            employee_id: params?.employee_id,
            payroll_onhold: params?.payroll_onhold ? params?.payroll_onhold : false
        }
    })
        .then((res) => {
            if (params?.resume_payroll) {
                toast.success(`${params?.name}'s payroll has been resumed`)
            }
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {
            if (params?.resume_payroll) {
                toast.error(err?.response?.data?.error?.[0]?.message)
            }
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}


export const GetCustomPayableEmployeeHelper = async (params) => {
    return await axiosInstance(`/finance/getCustomPayableEmployeeCheck`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            employee_fk: params?.employee_fk || null
        }
    })
        .then((res) => {
            return { message: "success", hasError: false, data: res?.data }
        }).catch(err => {    
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}

// employee payroll template configured
export const GetEmployeePayrollTemplateDetailsHelper = async (params) => {
    return await axiosInstance(`/finance/getEmployeePayrollTemplateDetails`, {
        method: "POST",
        baseURL: HRMS_FINANCE_API_URL,
        data: {
            domain_name: getDomain(),
            employee_id: params?.employee_id
        }
    })
        .then((res) => {
            return { message: "Template retrived successfully", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to retrived Template", hasError: false, data: err?.response?.data }
        })
} 